import { useSiteContext, useTranslation } from '@eti/providers';
import { css, etiColors, mediaQueries } from '@eti/styles';
import type { PreSelectedExtraProducts } from '../../../models';
import PreSelectedProduct from './PreSelectedProduct';

const borderStyle = `1px solid ${etiColors.grayScale[4.5]}`;

const productsWrapperStyles = (numberOfPreSelectedProducts: number) => css`
  border-left: ${borderStyle};
  display: grid;
  grid-template-columns: ${numberOfPreSelectedProducts === 1 ? '1fr' : '1fr 1fr'};
  margin-top: 8px;

  ${numberOfPreSelectedProducts !== 1 && `border-top: ${borderStyle}`};
  > div {
    border-bottom: ${borderStyle};
    border-right: ${borderStyle};
  }

  @media ${mediaQueries.xlarge.up} {
    justify-content: flex-end;
  }
`;

const descriptionTextStyles = css`
  font-size: 1rem;
  font-weight: 700;
`;
interface PreSelectedProductsProps {
  preSelectedExtraProducts: PreSelectedExtraProducts[];
}

const PreSelectedProducts = ({ preSelectedExtraProducts }: PreSelectedProductsProps) => {
  const { t } = useTranslation();
  const { partner } = useSiteContext();

  const descriptionText =
    t(`SelectedTrip.PreSelectedProducts.Header.${partner}`) ||
    t('SelectedTrip.PreSelectedProducts.Header.NoPartner');

  const numberOfPreSelectedProducts = preSelectedExtraProducts.length;

  return (
    <div>
      <span className={descriptionTextStyles}>{descriptionText}</span>
      <div
        className={productsWrapperStyles(numberOfPreSelectedProducts)}
        data-testid="preSelected-products-wrapper"
      >
        {preSelectedExtraProducts.map((preSelectedExtraProduct: PreSelectedExtraProducts) => (
          <PreSelectedProduct
            key={preSelectedExtraProduct.productId}
            numberOfPreSelectedProducts={numberOfPreSelectedProducts}
            preSelectedExtraProduct={preSelectedExtraProduct}
          />
        ))}
      </div>
    </div>
  );
};

export default PreSelectedProducts;
